"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRoleBranchSubjectImpl = void 0;
const emitter_1 = require("./emitter");
const groupRoleBranch_1 = require("./groupRoleBranch");
class GroupRoleBranchSubjectImpl {
    data = {};
    emitter;
    observers = [];
    constructor() {
        this.emitter = new emitter_1.Emitter();
    }
    attach(observer) {
        this.observers.push(observer);
    }
    notify() {
        this.observers.forEach(o => o.update());
    }
    set(groupRoleBranch) {
        let prev;
        const groupRoleBranchItem = this.data[groupRoleBranch.id];
        if (groupRoleBranchItem) {
            prev = { ...groupRoleBranchItem };
        }
        this.data[groupRoleBranch.id] = groupRoleBranch;
        this.notify();
        if (prev) {
            const e = {
                type: groupRoleBranch_1.GroupRoleBranchEventTypes.UPDATE,
                value: groupRoleBranch,
                oldValue: prev,
            };
            const event = new CustomEvent(e.type, { detail: e });
            this.emitter.dispatchEvent(event);
        }
        else {
            const e = {
                type: groupRoleBranch_1.GroupRoleBranchEventTypes.ADD,
                value: groupRoleBranch,
            };
            const event = new CustomEvent(e.type, { detail: e });
            this.emitter.dispatchEvent(event);
        }
    }
    getEventListener() {
        return this.emitter;
    }
    getState() {
        return Object.values(this.data);
    }
}
exports.GroupRoleBranchSubjectImpl = GroupRoleBranchSubjectImpl;
